import { Component, Vue, Prop } from "vue-property-decorator";
import DataTable from "@/components/DataTable/DataTable.vue";

import { exportCSVFile } from "@/utils/helpers/export-csv";
@Component({
  components: {
    DataTable
  }
})
export default class ReportsMixin<T> extends Vue {
  @Prop({ required: true, type: String })
  protected title!: string;

  @Prop({ default: false, type: Boolean })
  protected pending!: boolean;

  @Prop({ required: true, type: [Array, Object] })
  protected reportData!: T;

  protected sortable = true;

  protected toggleSortable() {
    this.sortable = !this.sortable;
  }

  protected exportCSVFile = exportCSVFile;
}
